import React from 'react';
import remoteControllerPage from '../img/remote-contorller-page-content.png';

export const RemoteControllerPageIcon = () => {
  return <img src={remoteControllerPage} alt="remote controller" style={{ width: '100%' }} />;
};
